import { PayloadAction } from '@reduxjs/toolkit';

import { QuantitySavingsState } from 'editor/src/store/quantitySavings/types';

const requestQuantitySavingsQuantityReducer = (state: QuantitySavingsState, action: PayloadAction<number>) => {
  state.sequence += 1;
  state.pendingQuantity = action.payload;
  state.lastQuantity = action.payload;
};

export default requestQuantitySavingsQuantityReducer;
